export const DsMenuDefaultProps = {
    open: false,
    disableAutoFocusItem: true
};
